import PropTypes from 'prop-types';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { trans } from '@spotahome/soyuz/client';
import { CloseButton } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './ValuePropositionBanner.scss';

const BULLET_POINTS = [
  {
    renderIcon: () => <DSIcon name="device_portrait" />,
    key: 'search.value_proposition.rentals'
  },
  {
    renderIcon: () => <DSIcon name="check_circle" />,
    key: 'search.value_proposition.fraud-protection'
  },
  {
    renderIcon: () => <DSIcon name="diamond" />,
    key: 'search.value_proposition.cancellation'
  }
];

const ValuePropositionBanner = ({ onHideClick }) => {
  const handleHideClick = () => {
    SoyuzAnalytics.sendGA4Event('send', {
      context: 'value-proposition-banner',
      action: 'close',
      value: 'click'
    });
    onHideClick();
  };

  return (
    <div className="value-proposition-banner">
      <h3 className="value-proposition-banner__title">
        {trans('homecard.banner.value-proposition.title')}
        <CloseButton
          className="value-proposition-banner__close-button"
          onClick={handleHideClick}
          color="black"
        />
      </h3>

      <ul className="value-proposition-banner__list">
        {BULLET_POINTS.map(bulletPoint => (
          <li
            className="value-proposition-banner__list-item"
            key={bulletPoint.key}
          >
            <div className="value-proposition-banner__list-item__icon">
              {bulletPoint.renderIcon()}
            </div>
            <div>
              <p className="value-proposition-banner__bullet-point__text--original">
                {trans(bulletPoint.key)}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

ValuePropositionBanner.propTypes = {
  onHideClick: PropTypes.func.isRequired
};

export default ValuePropositionBanner;
